import { toast } from 'sonner';

// Safe clipboard copy — never throws an unhandled rejection (which mounts the
// CRA error overlay and blocks clicks). Falls back to a toast on denial.
export const copyToClipboard = async (text) => {
  try {
    await navigator.clipboard.writeText(text);
    toast.success('Copied');
  } catch {
    toast.error('Copy failed — please select and copy manually');
  }
};

// U.S. phone display: normalize digits → (###) ###-####
export const formatPhone = (v) => {
  if (!v) return v;
  const d = String(v).replace(/\D/g, '');
  if (d.length === 10) return `(${d.slice(0, 3)}) ${d.slice(3, 6)}-${d.slice(6)}`;
  if (d.length === 11 && d[0] === '1') return `(${d.slice(1, 4)}) ${d.slice(4, 7)}-${d.slice(7)}`;
  return v;
};
